import { Modal } from 'react-bootstrap';
import Styles from './customModal.module.scss';

export const CustomModal = ({
	title,
	show,
	onClose,
	dialogStyles,
	headerStyles,
	bodyStyles,
	backdropStyles,
	hideHeader = true,
	children
}) => {
	return (
		<Modal
			show={show}
			onHide={onClose}
			backdropClassName={backdropStyles}
			dialogClassName={`${Styles.modalContainer} ${dialogStyles || ''}`}
		>
			{
				!hideHeader && <Modal.Header closeButton className={`${Styles.modalHeader} ${headerStyles || ''}`}>
					<Modal.Title>
						{title}
					</Modal.Title>
				</Modal.Header>
			}
			<Modal.Body className={`${`${Styles.modalBody} ${bodyStyles || ''}`} ${bodyStyles || ''}`}>
				{children}
			</Modal.Body>
		</Modal>
	);
};
